// 서명 획 추적(순수) — 손가락 하나만 따라가고 그린 길이를 더해, 점 하나 같은 짧은 획은 서명으로 받지 않게 한다.
export interface Point {
  x: number;
  y: number;
}

// 획 길이 합(CSS px)이 이만큼은 돼야 서명으로 본다 — 탭 한 번·점 하나를 거른다.
export const MIN_INK_PX = 40;

export const createStrokeTracker = (minInk: number = MIN_INK_PX) => {
  let active: number | null = null;
  let last: Point | null = null;
  let ink = 0;
  return {
    /** 다른 손가락이 그리는 중이면 false(무시). */
    down(pointerId: number, point: Point): boolean {
      if (active !== null) return false;
      active = pointerId;
      last = point;
      return true;
    },
    /** 그리는 손가락의 이동만 길이에 더하고 true. */
    move(pointerId: number, point: Point): boolean {
      if (pointerId !== active || !last) return false;
      ink += Math.hypot(point.x - last.x, point.y - last.y);
      last = point;
      return true;
    },
    /** 그리는 손가락을 뗐을 때만 true. */
    up(pointerId: number): boolean {
      if (pointerId !== active) return false;
      active = null;
      last = null;
      return true;
    },
    reset() {
      active = null;
      last = null;
      ink = 0;
    },
    ink: () => ink,
    enough: () => ink >= minInk,
  };
};

export type StrokeTracker = ReturnType<typeof createStrokeTracker>;
